import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-017d7fd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper t-smaller" }




export default /*#__PURE__*/_defineComponent({
  __name: 'RoundIcon',
  props: {
    icon: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: _normalizeClass(`fa-solid fa-${__props.icon}`)
    }, null, 2)
  ]))
}
}

})